var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProduct = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#231F20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m19 9.111-6.5 3.111L6 9.112M12.5 20v-7.778m0 7.778 6.5-3.111V9.11L12.5 6 6 9.111v7.778zm-3.25-9.333 6.5-3.111m-1.625 6.222L15.75 13m-1.625 2.333 1.625-.777"
})));
export default SvgProduct;